/**
 * Stable plan / tab ids shared by routing, context locking, Playwright helpers,
 * and CMS `planOrder`. Changing these breaks deep links and stored tier query
 * params — treat as public contracts, not display labels.
 */
export const ELITE_PLANS_ELITE_TAB_ID = 'elite'
export const ELITE_PLANS_ELITE_PRIME_TAB_ID = 'elite-prime'

/** Default `?tier=` when the URL omits a plan. */
export const ELITE_PLANS_DEFAULT_TIER = ELITE_PLANS_ELITE_TAB_ID

/** Query-string key used by `useElitePlansTier` to persist the selected tab. */
export const ELITE_PLANS_TIER_QUERY_PARAM = 'tier'

/** Query-string key the app sets to `dark` to render the dark header/hero. */
export const ELITE_PLANS_DISPLAY_MODE_QUERY_PARAM = 'displayMode'
